<template>
	<div class="flex flex-col gap-6">
		<router-link to="/podcasts" class="text-red hover:text-white">
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
				<path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
			</svg>
		</router-link>
		
		<div v-if="podcast" class="flex flex-col gap-6">
			<div class="flex flex-col md:flex-row md:items-center gap-6 md:gap-9">
				<figure class="w-full md:w-52 rounded-xl overflow-hidden">
					<img :src="podcast.icon" :alt="podcast.name" />
				</figure>
				<div class="flex-1 flex flex-col gap-3">
					<h3 class="font-bold leading-tight text-xl md:text-3xl">{{ podcast.name }}</h3>
					<div>
						<FavouriteButton :podcast="podcast" />
					</div>
					<p class="line-clamp-4">{{ podcast.description }}</p>
				</div>
			</div>

			<h2 class="font-bold text-xl">Avsnitt</h2>
			<ul class="grid grid-cols-1 md:grid-cols-2 gap-6">
				<li v-for="episode in podcast.episodes" :key="episode.linkid" class="flex flex-row gap-3 items-center">
					<EpisodeCard :episode="episode" />
				</li>
			</ul>
		</div>
		<div v-else>Poddens detaljer kunde inte hittas.</div>
	</div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { usePodcastStore } from '../stores/podcastStore'
import EpisodeCard from '@/components/EpisodeCard.vue'
import FavouriteButton from '@/components/FavouriteButton.vue'

const route = useRoute()
const store = usePodcastStore()

const podcastId = route.params.id

onMounted(async () => {
	if (podcastId) {
		await store.fetchPodcastDetails(podcastId)
	}
})

const podcast = computed(() => store.getPodcastDetailsById(podcastId))

</script>
